// Grant strike validation — PSD §9.6 (F9.6). Engine layer (framework-free).
import { daysBetween } from './dates';
/**
 * Validate option grants against the computed FMV / strike floor.
 * Flags any grant with a strike below the recommended strike or > 12 months after valuation.
 */
export function validateGrants(grants, headline, valuationDate) {
    const issues = [];
    const flagged = [];
    const fmv = headline.recommendedStrikePrice;
    for (const g of grants) {
        if (g.strikePrice < fmv - 0.005) {
            issues.push({
                severity: 'error',
                code: 'BELOW_FMV_GRANT',
                message: `Grant to "${g.holder}" strike $${g.strikePrice.toFixed(2)} < FMV $${fmv.toFixed(2)}.`,
                instrumentId: g.id,
            });
            flagged.push({ grant: g, fmv });
        }
        if (g.grantDate) {
            const gap = daysBetween(valuationDate, g.grantDate);
            if (gap > 365) {
                issues.push({
                    severity: 'warning',
                    code: 'GRANT_DATE_STALE',
                    message: `Grant to "${g.holder}" is ${gap} days after valuation (> 12 months).`,
                    instrumentId: g.id,
                });
            }
        }
    }
    return { issues, flaggedGrants: flagged };
}
//# sourceMappingURL=grantValidation.js.map